import { SalatiToneDetailsDto } from '../../../dto/salatitonedetails/salatitonedetailsdto';
import { APIResponse, APIResponseDtoImpl } from '../../apiresponse';

export interface SalatiToneDetailsResponse extends APIResponse
{
    getSalatiToneDetailsDto(): SalatiToneDetailsDto;
}

export class SalatiToneDetailsResponseDtoImpl extends APIResponseDtoImpl implements SalatiToneDetailsResponse
{
    private salatiToneDetailsResponseDto : SalatiToneDetailsDto;

    getSalatiToneDetailsDto(): SalatiToneDetailsDto
    {
        return this.salatiToneDetailsResponseDto;
    }
    setSalatiToneDetailsDto(salatiToneDetailsResponseDto: SalatiToneDetailsDto)
    {
        this.salatiToneDetailsResponseDto = salatiToneDetailsResponseDto;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/salati/salatitonedetails/salatitonedetailsresponse.tsx